<template>
  <v-menu v-model="open" class="filter-menu" left offset-x :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-badge color="marca-1" :value="filtersQuantity" :content="filtersQuantity" overlap>
        <mf-button type="icon" color="cinza-0" icon="filter_list" v-on:click.native="on.click" />
      </v-badge>
    </template>

    <v-card width="285px">
      <v-card-text>
        <p class="title">Filtros</p>
        <slot></slot>
        <mf-action-buttons
          :primary-button="{
            text: 'Aplicar',
            action: applyChanges,
            isVisible: true,
            isDisabled: false,
          }"
          :cancel-button="{
            text: 'Limpar',
            action: () => $emit('clear-filters'),
            isVisible: true,
            isDisabled: false,
          }"
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'FiltersMenuV2',
  props: {
    filtersQuantity: Number,
  },
  data: () => ({
    open: false,
  }),
  methods: {
    applyChanges() {
      this.$emit('apply-filters')
      this.open = false
    },
  },
}
</script>
